// extracted by mini-css-extract-plugin
export default {"imageShell":"StepImage_imageShell__BTWgU","image":"StepImage_image__YYD+n","buttonsShell":"StepImage_buttonsShell__F-hFr"};